export default "__VITE_ASSET__7624544d__"